import React from "react";
import CustomLayout from "../General/CustomLayout/CustomLayout";
import MinifiedHeader from "./MinifiedHeader";
import MinifiedContent from "./MinifiedContent";
import { useSelector } from "react-redux";
import useShowInsights from "../../hooks/useShowInsights";
import BuildTargetsDrawer from "../BuildTargets/BuildTargetsDrawer";
import AddAudienceModal from "../Modal/AddAudienceModal";
import InsightsDetailsModal from "../Modal/InsightsDetailsModal";
import NoSubCompareResultModal from "../ReportBuilder/NoSubscription/NoSubCompareResultModal";
import useLandingPageHandler from "../../hooks/useLandingPageHandler"

const MinifiedPage = () => {
    const { visibleAddAudienceModal, visibleInsightsModal } = useSelector((state) => state.reports);
    const { hasInsightPermission } = useShowInsights()

    useLandingPageHandler()

    return <CustomLayout className="minified" header={<MinifiedHeader />}>
        <MinifiedContent />
        <BuildTargetsDrawer />
        {visibleAddAudienceModal.visible && <AddAudienceModal visible={visibleAddAudienceModal.visible} />}
        {(visibleInsightsModal.visible && hasInsightPermission) && <InsightsDetailsModal data={visibleInsightsModal} />}
        {(visibleInsightsModal.visible && !hasInsightPermission) && <NoSubCompareResultModal data={visibleInsightsModal} />}
    </CustomLayout>
}

export default MinifiedPage